import { Platform, Pressable } from 'react-native'
import { router } from 'expo-router'
import AppConfig from 'config'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'

export default function OpticalMeasureDevTile() {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()

  if (!AppConfig.isDev || Platform.OS === 'web') {
    return null
  }

  const onPress = () => router.navigate('/dev/optical-measure')

  return (
    <Pressable
      onPress={onPress}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      className="w-full"
    >
      <TileBlur
        variant="small"
        title="Optical Measure"
        desc="Measure optical parameters with camera. Only visible in development mode currently."
        badge={{ text: 'Development Only', variant: 'attention' }}
        cta={
          <Button
            noninteractive
            animation={animation}
            onPress={onPress}
            size="sm"
            variant="outlined"
            label="Start"
          />
        }
        glassProps={{
          animation,
          image: require('@/images/optical-measure.png'),
          imageWrapperStyle: {
            width: '105%',
            height: '105%',
          },
          imageStyle: {
            transform: [
              { translateX: 110 },
              { translateY: Platform.select({ default: 45, web: 50 }) },
              { rotate: '-10deg' },
            ],
          },
          blur: Platform.select({ default: 100, web: 25 }),
          blurStyle: {
            opacity: Platform.select({ default: 0.55, web: 0.65 }),
            transform: [
              { translateX: Platform.select({ default: 75, web: 10 }) },
              { translateY: Platform.select({ default: 40, web: 50 }) },
              { scale: Platform.select({ default: 0.7, web: 0.6 }) },
              { rotate: '-5deg' },
            ],
          },
        }}
      />
    </Pressable>
  )
}
